// src/hooks/useRegistrationStatus.js
import { useState, useEffect } from 'react';

// Whether new accounts can sign up (toggled on Admin → Users).
// null while loading; false if the check fails.
const useRegistrationStatus = () => {
  const [registrationEnabled, setRegistrationEnabled] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/settings/registration-status')
      .then(res => res.json())
      .then(data => { if (!cancelled) setRegistrationEnabled(!!data.registrationEnabled); })
      .catch(() => { if (!cancelled) setRegistrationEnabled(false); });
    return () => { cancelled = true; };
  }, []);

  return registrationEnabled;
};

export default useRegistrationStatus;
